// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "main." + "d81d6057a466c4cff8d7" + ".js";
};